export default {
  error: "Désolé, quelque chose s'est mal passé",
};
